<!--Report>Delivery Order Summary页面-->
<template>
    <div class="mains">
        <div ref="refTopHeight">
            <a-row style="border: 1px solid #e8eaec;">
                <a-col>
                    <a-button size="small" class="mg5" @click="query">{{$t('job.Query')}}</a-button>
                    <a-button size="small" class="mg5" @click="exportData">{{$t('generic.Export')}}</a-button>
                </a-col>
            </a-row>
            <a-form :form="formQuery" style="margin-top: 20px;margin-left: 10px;">
                <a-row>
                    <a-col span="3">
                        <a-form-item>
                            <b>Expect Delivery Date:</b><br>
                            <a-date-picker @change="query" size="small" format="YYYY-MM-DD" v-model="dateFrom"/>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item>
                            <b>To:</b><br>
                            <a-date-picker @change="query" size="small" format="YYYY-MM-DD" v-model="dateTo"/>
                        </a-form-item>
                    </a-col>
                    <a-col offset="8">
                        <a-form-item>
                            <b>Project:</b><br>
                            <a-checkbox @change="query" v-for="item in projectList" v-model="item.checked" :value="item.projectCode">{{item.projectCode}}</a-checkbox>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <a-row>
                <a-col align="right" style="margin: 0 -7px 5px 0">
                    <!--分页-->
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            :showSizeChanger="showSizeChanger"
                            :showQuickJumper="showQuickJumper"
                    />
                </a-col>
            </a-row>
        </div>
        <a-row>
            <!--列表-->
            <vxe-table
                    border
                    resizable
                    stripe
                    column-key
                    highlight-hover-column
                    highlight-hover-row
                    highlightCurrentRow
                    show-header-overflow
                    show-overflow
                    :sort-config="{multiple: true, trigger: 'cell'}"
                    :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                    keep-source
                    :keyboard-config="{isArrow: true}"
                    :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                    align="center"
                    :data.sync="pagingGridList"
                    class="mytable-style "
                    :height="getLeftHeight"
                    ref="refLeftPagingGrid"
                    size="mini">
                <template v-slot:empty>
                    <a-empty></a-empty>
                </template>
                <vxe-table-column field="district" title="District" sortable></vxe-table-column>
                <vxe-table-column field="projectCode" title="Project Code" sortable></vxe-table-column>
                <vxe-table-column field="soNo" title="So No" sortable></vxe-table-column>
                <vxe-table-column field="status" title="So Status" sortable></vxe-table-column>
                <vxe-table-column field="contact" title="Contact" sortable></vxe-table-column>
                <vxe-table-column field="phone" title="Phone" sortable></vxe-table-column>
                <vxe-table-column field="addressEn" title="Address(En.)" width="300" sortable></vxe-table-column>
                <vxe-table-column field="addressCn" title="Address(Cn.)" width="300" sortable></vxe-table-column>
                <vxe-table-column field="total_qty" title="#Carton" sortable></vxe-table-column>
                <vxe-table-column field="count_of_cartons" title="#Bts" sortable></vxe-table-column>
            </vxe-table>
        </a-row>
    </div>
</template>

<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import moment from 'moment';
    import axios from "axios";
    import cookie from "../../../api/cookie";
    import store from "../../../store";

    export default{
        data(){
            return{
                pagingTotal: 0, // 总数
                pagingSize: 20, // 条数
                currentVal: 1, // 当前选中的页数
                showSizeChanger:true,//是否显示页码下拉框
                showQuickJumper:false,//是否显示快速跳转输入框
                pageSizeOptions:['10', '20', '30', '50','100','200','500','1000'],
                projectList: [],//当前OrgCode下的所有Project数据
                pagingGridList: [],//列表数据
                formQuery: this.$form.createForm(this, {}),
                leftTopHeight: 0,
                isChecked:true,//是否选中
                dateFrom:'',
                dateTo:'',
            }
        },
        mounted() {
            this.leftTopHeight = this.$refs.refTopHeight.clientHeight;//左侧列表上部份div的高度
        },
        computed:{
            getLeftHeight(){
                return document.body.clientHeight - this.leftTopHeight - 100;//自适应查询列表的高度
            },
        },
        created() {
            this.queryProject();
        },
        methods:{
            queryProject(){
                let nowDate = new Date();
                let date = {
                    year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate() + 1,
                }
                let month = date.month>10?date.month:'0'+date.month
                let dayFrom = date.date>10?date.date:'0'+date.date
                let dayTo = dayFrom
                this.dateFrom = moment(date.year + '-' + month + '-' + dayFrom,'YYYY-MM-DD');
                this.dateTo = moment(date.year + '-' + month + '-' + dayTo,'YYYY-MM-DD');
                ajax.get(api.GETPROJECTCODES,null).then(res=>{
                    if(res.code == 200){
                        this.projectList = res.data;//列表
                        this.query();
                    }
                })
            },
            query(){
                let projects = '';//查询选中的Project数据
                for(let i in this.projectList){
                    if(this.projectList[i].checked){
                        if(projects.length > 0){
                            projects += ",";
                        }
                        projects += this.projectList[i].projectCode;
                    }
                }
                let params = {//配置查询条件
                    dateFrom : this.dateFrom == null ? '' : moment(this.dateFrom).format('YYYY-MM-DD'),
                    dateTo : this.dateTo == null ? '' : moment(this.dateTo).format('YYYY-MM-DD'),
                    projects : projects,
                    currentVal : (this.currentVal - 1) * this.pagingSize,
                    pagingSize : this.pagingSize,
                }
                ajax.get(api.GETDELIVERYORDERSUMMARYLIST,params).then(res=>{
                    if(res.code == 200){
                        this.pagingGridList = res.data;//列表
                        this.pagingTotal = res.total;
                    }
                })
            },
            tableChangePage(current) {
                this.currentVal = current;
                this.query();
            },
            onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.query();
            },
            exportData(){
                let projects = '';//查询选中的Project数据
                for(let i in this.projectList){
                    if(this.projectList[i].checked){
                        if(projects.length > 0){
                            projects += ",";
                        }
                        projects += this.projectList[i].projectCode;
                    }
                }
                axios.defaults.timeout =  1000*60*60;//设置请求超时时间:1h
                store.commit("updataLoading", { pbLoading: true });
                axios.get(ajax.ajaxUrl() + api.EXPORTDELIVERYORDERSUMMARY, {
                    params: {
                        dateFrom : this.dateFrom == null ? '' : moment(this.dateFrom).format('YYYY-MM-DD'),
                        dateTo : this.dateTo == null ? '' : moment(this.dateTo).format('YYYY-MM-DD'),
                        projects : projects,
                        currentVal : (this.currentVal - 1) * this.pagingSize,
                        pagingSize : this.pagingSize,
                    },
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function (data) {
                    if (!data) {
                        return;
                    }
                    let blob = new Blob([data.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                    });
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", "DeliveryOrderSummary.xlsx");
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
                    .catch(function (error) {
                        alert(error);
                });
                store.commit("updataLoading", { pbLoading: false });
            },
        }
    }
</script>

<style lang="less" scoped>
    .mains{
        height: 100%;
        width: 100%;
        background-color: white;
        float: left;
    }
</style>